// API helpers para fetchear poses desde Supabase.
//
// Tabla `poses`:
//   id, nombre, filename, categoria, areas_principales,
//   areas_secundarias, cantidad_personas
//
// Las imágenes son públicas y viven en el bucket `system`, path
// `poses/<filename>`.

import { supabase } from '../../lib/supabase';

const POSE_BASE_URL =
  'https://kywexemefeblsysfxkpu.supabase.co/storage/v1/object/public/system/poses';

export interface PoseV2 {
  id: string;
  nombre: string;
  filename: string;
  categoria: string | null;
  imageUrl: string;
  /** Miniatura para DIBUJAR en grillas, si la pose tiene una. `imageUrl` sigue siendo la
   *  del original: es la que viaja como referencia y la que `leerFirma` sabe renovar
   *  (ADR-2026-09-25-revision-greptile-la-miniatura-no-viaja-en-el-adjunto). */
  thumbUrl?: string;
  /** Áreas principales del cuerpo que aparecen — para filtros recomendados. */
  areasPrincipales: string[];
  /** Cantidad de personas que aparecen en la pose. Se usa para filtrar
   *  según la cantidad de modelos seleccionados en multi-mode. */
  cantidadPersonas: number;
  /** true si es una pose personalizada del cliente (tabla
   *  `poses_personalizadas`). Las globales no traen este flag. */
  isCustom?: boolean;
}

/** Categorías que usa la UI para filtrar la grilla — mismas que en
 *  PruebaNuevaInterfaz. */
export const POSE_CATEGORIES: { id: string; label: string }[] = [
  { id: 'recomendado', label: 'Recomendados' },
  { id: 'cuerpo_completo', label: 'Cuerpo completo' },
  { id: 'plano_medio', label: 'Plano medio' },
  { id: 'detalle_close-up', label: 'Detalle / Close-up' },
];

/** Devuelve todas las poses publicadas, ordenadas por created_at. */
export async function fetchAllPoses(): Promise<PoseV2[]> {
  const { data, error } = await supabase
    .from('poses')
    .select(
      'id, nombre, filename, categoria, areas_principales, cantidad_personas',
    )
    .order('created_at');
  if (error || !data) {
    console.error('[posesApi] fetchAllPoses error', error);
    return [];
  }
  return (data as any[]).map((p): PoseV2 => ({
    id: String(p.id),
    nombre: (p.nombre as string) || 'Pose',
    filename: (p.filename as string) || '',
    categoria: (p.categoria as string) || null,
    imageUrl: p.filename
      ? `${POSE_BASE_URL}/${encodeURIComponent(p.filename)}`
      : '',
    areasPrincipales: Array.isArray(p.areas_principales)
      ? (p.areas_principales as string[])
      : [],
    cantidadPersonas:
      typeof p.cantidad_personas === 'number' ? p.cantidad_personas : 1,
  }));
}
